const stringUtil = require('../string/stringUtil');
const validator = require('../validator/validator');
const constants = require('../domain/constants');
const localizationUtils = require('../domain/localizationUtils');

module.exports.convertToCurrencyFormat = function(value, treatEmptyAsZero)
{
    value = value + "";
    var numericValue = 0;
    if (stringUtil.isStringNullOrEmpty(value))
    {
        if (!treatEmptyAsZero)  
            return "";
            
        value = "0";
    }

    if (!validator.isNumeric(value))
        return "";

    var numericValue = 1 * value;

    if (numericValue < constants.numericThresholdValue)
        numericValue = 0.0;

    return localizationUtils.getCurrentCurrencyFormatter().format(numericValue);
}

module.exports.convertToAmountFormat = function(value, treatEmptyAsZero)
{
    value = value + "";
    var numericValue = 0;
    if (stringUtil.isStringNullOrEmpty(value))
    {
        if (!treatEmptyAsZero)  
            return "";
            
        value = "0";
    }

    if (!validator.isNumeric(value))
        return "";

    var numericValue = 1 * value;

    if (numericValue < constants.numericThresholdValue)
        numericValue = 0.0;

    return numericValue.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
}

module.exports.convertToPercentageFormat = function(value)
{
    return this.roundUp(value, 2) + "%";;
}

module.exports.roundUp = function (value, decimalPoints)
{
    if (!validator.isNumeric(value))
        return null;

    return  (value * 1).toFixed(decimalPoints) * 1;
}
